export default __webpack_public_path__ + "static/media/texmex002.679aa516.jpg";